export enum ComponentType {
  simple = 1, /// //////// input, label, select etc...
  itemContainer = 2, /// //////// row, steps, tabs etc...
  container = 3, /// //////// div, panel, group-box etc...
  abstractContainer = 4, /// //////// step, tab-item, list-item etc...
  responsiveColumn = 5, /// //////// Col...
  responsiveRow = 6, /// //////// Row...
  none = 8,
  abstractItemContainer = 9,
  noneEditable = 10,
  fixedHeader = 11,
  fixedFooter = 12,
  layoutHeader = 13,
  layoutFooter = 14,
  layoutLeft = 15,
  layoutRight = 16,
  pageHeader = 17,
  pageFooter = 18
}

export enum GridSystemCount {
  grid24 = 24,
  grid12 = 12,
  percentage = 100
}
